import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { AsyncReduxState, initialAsyncReduxState } from '../../../redux/@config/AsyncReduxState';
import { Exchange, ShiftExchange } from '../../entities/Exchange/Exchange';

export interface ExchangesState extends AsyncReduxState<any> {
    exchangeRequests: Exchange[];
    shiftExchanges: ShiftExchange[];
}

const initialState: ExchangesState = {
    ...initialAsyncReduxState,
    exchangeRequests: [],
    shiftExchanges: [],
};

export const exchangesSlice = createSlice({
    name: 'exchangesReducer',
    initialState,
    reducers: {
        setIsLoading(state, action: PayloadAction<boolean>): ExchangesState {
            return {
                ...state,
                isLoading: action.payload,
            };
        },
        setIsSuccessful(state, action: PayloadAction<boolean>): ExchangesState {
            return {
                ...state,
                isSuccessful: action.payload,
            };
        },
        setError(state, action: PayloadAction<string>): ExchangesState {
            return {
                ...state,
                error: action.payload,
            };
        },
        setExchangeRequests(state, action: PayloadAction<Exchange[]>): ExchangesState {
            return {
                ...state,
                exchangeRequests: action.payload,
            };
        },
        setShiftExchanges(state, action: PayloadAction<ShiftExchange[]>): ExchangesState {
            return {
                ...state,
                shiftExchanges: action.payload,
            };
        },
    },
});

export const {
    setIsLoading,
    setIsSuccessful,
    setError,
    setExchangeRequests,
    setShiftExchanges,
} = exchangesSlice.actions;

export default exchangesSlice.reducer;
